// Type guard that checks if map is v2 Map
export function isMap2(map) {
    return 'type' in map && map.type === 'GeoreferencedMap';
}
// Type guard that checks if annotation is v1 Georeference Annotation
export function isAnnotation1(annotation) {
    return ('source' in annotation.target &&
        typeof annotation.target.source === 'object');
}
